import { AIModel, AIProvider, ChatRequest, ChatResponse } from '../../schemas/chat';
import api from '../../lib/api';
import type { AxiosResponse } from '../../lib/api';

// AI/LLM API with generic type support
export const aiAPI = {
  getModels: (): Promise<AxiosResponse<AIModel[]>> => api.get<AIModel[]>('/api/v1/models'),

  getProviders: (): Promise<AxiosResponse<AIProvider[]>> =>
    api.get<AIProvider[]>('/api/v1/models/providers'),

  chat: (data: ChatRequest): Promise<AxiosResponse<ChatResponse>> =>
    api.post<ChatResponse>('/api/v1/models/chat', data),

  streamChat: (
    data: ChatRequest,
    onMessage?: (chunk: string) => void
  ): Promise<AxiosResponse<ChatResponse>> => {
    return api.post<ChatResponse>('/api/v1/models/chat/stream', data, {
      responseType: 'stream',
      onDownloadProgress: (progressEvent: any) => {
        const chunk = progressEvent.currentTarget?.response;
        if (onMessage && chunk) {
          onMessage(chunk);
        }
      },
    } as any);
  },

  // Model management
  createModel: (modelData: Partial<AIModel>): Promise<AxiosResponse<AIModel>> =>
    api.post<AIModel>('/api/v1/models/', modelData),

  updateModel: (modelId: string, modelData: Partial<AIModel>): Promise<AxiosResponse<AIModel>> =>
    api.put<AIModel>(`/api/v1/models/${modelId}`, modelData),

  deleteModel: (modelId: string): Promise<AxiosResponse<void>> =>
    api.delete<void>(`/api/v1/models/${modelId}`),

  testModel: (
    modelId: string,
    message: string
  ): Promise<AxiosResponse<{ response: string; latency: number }>> =>
    api.post<{ response: string; latency: number }>(`/api/v1/models/${modelId}/test`, {
      message,
    }),
};
